// extracted by css-extract-rspack-plugin
export default {"container":"DeleteTaskDialog-module__container__mQrFI","error":"DeleteTaskDialog-module__error__KZpqn","buttonStack":"DeleteTaskDialog-module__buttonStack__ly2LC"};